import React, { useContext, useRef } from 'react';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import PbxContext from '../../context/PbxContext';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

const ChartBySector = ({ getRows }) => {
  const getItensStateGlobal = useContext(PbxContext);
  const { storageDataReport } = getItensStateGlobal;

  const rawGlobalQueues = storageDataReport.globalQueues || {};
  const globalEntry = (rawGlobalQueues && rawGlobalQueues.global && typeof rawGlobalQueues.global === 'object')
    ? rawGlobalQueues.global
    : { atendidas: 0, perdidas: 0 };
  const globalQueues = { ...rawGlobalQueues, global: globalEntry };

  const chartCallsQueuesGlobalRef = useRef(null);

  const getDataToRequestFilter = (event) => {
    if (chartCallsQueuesGlobalRef.current) {
    const chart = ChartJS.getChart(chartCallsQueuesGlobalRef.current);
    const clickedElements = chart.getElementsAtEventForMode(event, 'nearest',{ intersect: true }, true);
    if (clickedElements.length > 0) {
      const firstElement = clickedElements[0];
      let labelType = chart.data.datasets[firstElement.datasetIndex].label;
      const labelIndexClicked = chart.data.labels[firstElement.index];

      labelIndexClicked === 'Não Atendidas' ? labelType = 'perdida' : labelType = 'atendida';
      getRows('queues-global', labelIndexClicked, labelType);
    }
   }
  };

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'none',
      },
      title: {
        display: true,
        text: 'Total Global Recebidas Externas (Todos Setores)',
      },
    },
  };
  

  const valueLabelsAtendidas = [{ 'Atendidas': globalEntry.atendidas ?? 0, 'Não Atendidas': globalEntry.perdidas ?? 0 }];
  const labels = ['Atendidas', 'Não Atendidas'];
  
  const data = {
    labels,
    datasets: [
      {
        label: '',
        data: labels.map((label) => valueLabelsAtendidas[0][label]),
        backgroundColor: ['rgba(30, 144, 255, 0.7)', 'rgba(255, 99, 132, 0.5)'],
        datalabels: {
          align: 'top'
        },
      },
    ],
  };


  return (
    <div className="column is-half">
      <h2 className="has-text-centered is-size-5">Chamadas Global</h2>
        <Bar options={options} data={data} plugins={[ChartDataLabels]} ref={ chartCallsQueuesGlobalRef } getElementAtEvent={(_, event) => getDataToRequestFilter(event)} />
    </div>
  );
}

export default ChartBySector;
